import { Opportunity, type Organization } from "@entities";
import { type EntityFilter } from "remult";

/** Admin-only: opportunities table "פתוחות" tab filter. Do not import from weme-app. */
export const getFutureOpenOpportunitiesWhere = (
  organization?: Organization,
): EntityFilter<Opportunity> => ({
  organization,
  $and: [
    Opportunity.matchesOpportunitiesTableTabSignals({
      tab: "futureOpen",
      rowScope: "roots",
    }),
  ],
});
